package one.healthium.content.navigation.insights

import com.arkivanov.decompose.ComponentContext
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.models.ActionModel

class DefaultInsightsComponent(
    componentContext: ComponentContext,
    private val onActionClicked: (ActionModel) -> Unit,
) : InsightsComponent, ComponentContext by componentContext {
    override fun onActionClicked(action: ActionModel) {
        onActionClicked.invoke(action)
    }

    override fun onContentClicked(options: ContentOptions) {
        when (options) {
            is ContentOptions.Insight -> onActionClicked(
                ActionModel.Insight(options.id)
            )

            is ContentOptions.Recipe -> onActionClicked(
                ActionModel.Recipe(options.id)
            )

            is ContentOptions.MealPlan -> onActionClicked(
                ActionModel.MealPlan(options.id)
            )

            is ContentOptions.Workout -> onActionClicked(
                ActionModel.Workout(options.id)
            )

            is ContentOptions.Category -> onActionClicked(
                ActionModel.Category(options.id)
            )
        }
    }
}